module.exports = __webpack_public_path__ + "static/media/02.022.b8496188.webp";